import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, PRICE } from '../data/content';
export function BonusSection() {
  return <section aria-labelledby="bonos" className="bg-ink-900" data-id="element-16" data-mp="1ofc5fttsurgy">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingBottom: "4px",
      paddingTop: "9px"
    }} data-id="element-17" data-mp="22g532nfee2oa">
        <div className="mx-auto max-w-3xl text-center" data-id="element-18" data-mp="1yfcqplb8bhns">
          <p className="inline-flex items-center gap-2 rounded-full border border-ball-400/30 bg-ball-400/10 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-ball-400" data-id="element-19" data-mp="1ao7d7csrh1gn">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-20" data-mp="15njcfzeqd698" />
            100% gratis
          </p>
          <h2 id="bonos" className="mt-5 font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-21" data-mp="1eq2ckbr4t4rs">
            5 bonos exclusivos
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-300" data-id="element-22" data-mp="qywxvzwxgij2">
            Solo por comprar hoy. Valorados en <span className="text-white" data-id="element-23" data-mp="mymgzs7lk7pf">{PRICE.bonusValue}</span>. Tuyos sin
            coste adicional.
          </p>
        </div>

        <ul className="mx-auto mt-10 max-w-4xl space-y-4" data-id="element-24" data-mp="2er66qwsmfri3">
          {bonuses.map(bonus => <li key={bonus.number} className="grid gap-5 rounded-2xl border border-ink-600 bg-ink-800 p-6 sm:grid-cols-[132px_1fr] sm:items-start sm:gap-6" data-id="element-25" data-mp="2ep36zl1o2k06">
              <img src={bonus.cover} alt={`Portada del bono ${bonus.number}: ${bonus.title}`} className="mx-auto w-32 shrink-0 rounded-md shadow-lg shadow-black/40 sm:mx-0 sm:w-full" data-id="element-26" data-mp="2ofxvyx6arxpb" />
              <div data-id="element-27" data-mp="1vriiwg6q7pgm">
                <span className="font-display text-xs uppercase tracking-[0.25em] text-court-400" data-id="element-28" data-mp="1vt3em94s1eg2">
                  Bono {bonus.number}
                </span>
                <div className="mt-2 flex flex-wrap items-center gap-3" data-id="element-29" data-mp="25q83whtx5q13">
                  <h3 className="font-semibold text-white sm:text-lg" data-id="element-30" data-mp="25o51szfhs6g0">{bonus.title}</h3>
                  <span className="inline-flex shrink-0 items-center gap-2 rounded-full bg-ink-700 px-3 py-1 text-xs font-bold uppercase tracking-wider text-slate-400" data-id="element-31" data-mp="3c6a8klchmim8">
                    <span className="line-through" data-id="element-32" data-mp="1h23xhm3abvcy">{bonus.value}</span>
                    <span className="text-ball-400" data-id="element-33" data-mp="1c4typfu0a7cg">Gratis</span>
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-slate-400" data-id="element-34" data-mp="1q4d6u8mthior">{bonus.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}